import { passwordReset } from "@api/auth/passwordReset/path";
import { signIn } from "@api/auth/signIn/path";
import { signOut } from "@api/auth/signOut/path";
import { signUpApplicant } from "@api/auth/signUp/applicant/path";

export const auth = {
  passwordReset,
  signIn,
  signUpApplicant,
  signOut,
};
